export const UFormSeatingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_8315_4768)" />
      <defs>
        <pattern
          id="pattern0_8315_4768"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8315_4768" transform="scale(0.0434783)" />
        </pattern>
        <image
          id="image0_8315_4768"
          width="23"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAIAAABvSEP3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAzpJREFUeNqklbtLI1EUxp3JxAmKbDTrA8VC8QEGBdFqtROTRm12DbgGBB9oZWEh2Ar+BRZaWFuKYC2IIIrr+20hySK+YGNi1LwT9ze5s9nsRlLs3uIyc+ec73znO+fckZxfnRcXFzn/vCQpHosrgUBQVuR3DSKRSCIRV1WTJEmhUIhdVdUMECkajSiyQU4kEpkQ0Wi0qqqqsLDw+PgYuKampng8fnZ2ZjQa/0J5e3szNDRYfU++TBb19fULCwsOh8Pv95vN5rm5ue7u7vPz86urK0VR0lHI6P1cIFJRUQERWZbr6upAxNNkMtXW1sIo0155L88oJNfW1ubn5ysrK9m9Xm95eTkEFxcXE8kF+h9eXz73ur+70nNpbm5ua2sjJopykpubC3Q4HOYZOvgvLS09PDyIvLRPobDOheCBQIAgsVgMlJGRkSzF3djYQB2DwUAAcPWMcAZ4fHy8rKxsdnb29fVVWAvyKWfcNC3jcXh1dXV1dnYuLy9vf9vWUWBut9vHxsaErqenp8KNuqyuropocJycnGxtbcUYCjMzM3l5eVarta+vjyJqKKT6+PjIZxzcbjcBBcr19fXR0RHW5As61uL85eXl9va2pqbm5uaGc0mSFaHZ/v5+f39/UVHR+vr60NCQsKbB1OQCRU4ujbyiADc4ONjY2Hh4eKjVS5J0XfLz8202W3FxMfEhn0VaECH7Kbl4QGldl2Aw2NHRMTo6KiQ8ODjIgkKMkpKS6elp1GlpaXH0Op78TzrJu7s7eBKHHs8+w+RFT1xeXvJMHcKRsCx0UU0mMkRti8WyubmZvVkg+/z8PDw8TIFOTk5E4yV1icXMH8xOp5N+odmRPbsu0Onp6Wlvb19ZWaEVfukSCtnsdriIKu7t7WXXpbS0dGpqCiymdGtry+f16bq4XC6Px8MQ7e7upm4QyKf7Iyc71UTBnZ0d4DAOhoLAJXVRVS7NgYGBgoICBKKPUQfm9/f3KSBM+cROQX0+38TERHV1NdMkabJIv2caOWgcEMVMCo7pNwCHYqwgxTTxCmvCaDPNizBN3am8GhSNAnHSMzLm6plyjo1IXCMiS8pHi8Xzw/Mfv4Acg6z8FGAAlmTDs6FPB6wAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};
